import { useQuery } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '../lib/cache'

export interface VendorOption {
  value: string
  label: string
}

async function fetchVendors(): Promise<VendorOption[]> {
  const res = await axios.get<VendorOption[]>('/api/v1/insure/insurance/vendors/')
  return res.data
}

export function useVendors() {
  const {
    data: vendors = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: [CacheKeys.INSURANCE_VENDORS],
    queryFn: fetchVendors,
    staleTime: Infinity,
  })

  function vendorLabel(value: string): string {
    return vendors.find((v) => v.value === value)?.label ?? value
  }

  return { vendors, isLoading, isError, vendorLabel }
}
